import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetVolumeComparisonCard";
/**
 * ① 成交量对比卡（volbars）。 Figma：94103:23154
 */

import { cn } from "utils";
import { SignalCardShell } from "./SignalCardShell";
import type { SignalCardAssetProps } from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetVolumeComparisonCardProps extends SignalCardAssetProps {
  volumeMultiplier: string;
  /** 0–1 relative bar fill for current volume */
  currentVolumeRatio: number;
  /** 0–1 relative bar fill for average volume */
  avgVolumeRatio: number;
}

const VolumeBar = ({
  ratio,
  barClass,
}: {
  ratio: number;
  barClass: string;
}) => (
  <div className="h-1.5 flex-1 overflow-hidden rounded-[10px] bg-background_white_overlay5">
    <div
      className={cn("h-full rounded-[8px]", barClass)}
      style={{ width: `${Math.min(100, Math.max(0, ratio * 100))}%` }}
    />
  </div>
);

export const AssetVolumeComparisonCard: React.FC<
  AssetVolumeComparisonCardProps
> = ({ volumeMultiplier, currentVolumeRatio, avgVolumeRatio, ...asset }) => {
  return (
    <SignalCardShell {...asset}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-col justify-center">
          <p className="headline_regular_l text-content_brand_primary">
            {volumeMultiplier}
          </p>
          <p className="body_medium_s text-content_tertiary">
            {I18n.t("average volume")}
          </p>
        </div>
        <div className="flex w-[160px] flex-col gap-2">
          <div className="flex items-center gap-3">
            <span className="w-[60px] shrink-0 body_medium_s text-content_tertiary">
              {I18n.t("Current")}
            </span>
            <VolumeBar
              ratio={currentVolumeRatio}
              barClass="bg-content_aura_lv1_primary"
            />
          </div>
          <div className="flex items-center gap-3">
            <span className="shrink-0 body_medium_s text-content_tertiary">
              {I18n.t("20-day avg")}
            </span>
            <VolumeBar
              ratio={avgVolumeRatio}
              barClass="bg-content_aura_lv2_primary"
            />
          </div>
        </div>
      </div>
    </SignalCardShell>
  );
};
